// extracted by mini-css-extract-plugin
export default {"brandPromo":"GF-z","carousel":"HF-z"};